import { createGlobalStyle } from "styled-components";
/**
 * 字体，来自于iconfont
 * @author James Zhang
 */
// tslint:disable-next-line:variable-name
export const IconFont = createGlobalStyle `

.gago-frame-jiage {
    width: 1em;
    height: 1em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
}

`;
//# sourceMappingURL=style.js.map